export default __webpack_public_path__ + "static/media/fpb50004.70ff42a2.png";